import InstrumentTrack from './InstrumentTrack.js';
import ParameterContext from 'effects/ParameterContext.js';
import {SAMPLED_INSTRUMENT} from 'constants/instrument-types.js';
import SampledInstrument from 'instruments/SampledInstrument.js';
import ethereum from 'decentralized/ethereum.js';
import {
    setTrackIsLoading} from 'actions/index.js';

const presets = ethereum.presets;

class SampledInstrumentTrack extends InstrumentTrack {
    constructor(
        trackNumber,
        sequencerEngine,
        mixSession,
        numberOfPatterns,
        update,
        subSequence,
        createSynth=true) {
        super(trackNumber, sequencerEngine, mixSession, numberOfPatterns, update, subSequence, false);

        this.setInstrument(
            new SampledInstrument(
                sequencerEngine, mixSession,
                new ParameterContext().forTrack(this),
                this));

        this.name = "Sampled Instrument";
        this.gated = true;
    }

    getInstrumentType() {
        return SAMPLED_INSTRUMENT;
    }

    createNewInstrument() {
        this.instrument = undefined;
        this.setInstrument(new SampledInstrument(
                this.sequencerEngine, this.mixSession,
                new ParameterContext().forTrack(this),
            this));
        this.gated = true;
    }

    get tempo() {
        let selectedSampler = this.selectedSampler || this.instrument.defaultSampler;
        if (selectedSampler === undefined) {
            return 0;
        }
        return selectedSampler.tempo;
    }

    async auditionPreset(preset) {
        let presetName = preset.name;
        let data = await presets.getPresetData(preset);

        this.fromJson(data.trackParameters);
        this.presetName = presetName;
        this.update();
    }

    async fromJson(json, isFullTrack, loadPreset, ignoreId, isPreset) {
        await super.fromJson(json, isFullTrack, loadPreset, ignoreId, isPreset);
        if (this.instrument.defaultSampler) {
            this.sample = this.instrument.defaultSampler.sample;
        }
    }

    loadTrackInfo(x, sound) {
        let selectedSampler = this.selectedSampler || this.instrument.defaultSampler;
        if (selectedSampler) {
            this.sample = sound;
            selectedSampler.auditionSound(sound);
            this.presetName = sound.name;
            this.sequencerEngine.update(); 
        }

        this.store.dispatch(setTrackIsLoading(this.subSequence.id, this.trackNumber, false));
    }

    restart() {
        super.restart();
        if (this.isFrozen) {
            return;
        }
        this.instrument.triggerCounters = {};
        this.instrument.cache = {};
        this.instrument.voices.clear();
    }

    start() {
        super.start();
        if (this.isFrozen) {
            return;
        }

        this.restart();
    }

    onNewStep(step, time) {
        if (this.isFrozen) {
            super.onNewStep();
            return;
        }
        super.onNewStep();
        this.instrument.onNewStep(step, time);
    }

    getSamplesStream() {
        let selectedSampler = this.selectedSampler || this.instrument.defaultSampler;
        if (selectedSampler) {
            return selectedSampler.samplesStream;
        }

        return this.samplesStream;
    }

    getCopy(constr, sequencerEngine) {
        return super.getCopy((a,b,c,d,e,f) => new SampledInstrumentTrack(a,b,c,d,e,f), sequencerEngine);
    }

    async makePublicIfNeeded() {
        await this.instrument.makePublicIfNeeded();

        for (let i in this.effectsChains) {
            await this.effectsChains[i].makePublicIfNeeded();
        }
    }

    isMonophonic() {
        return this.instrument.monophonic;
    }
}


export default SampledInstrumentTrack;
